/* NecksLevel — native homepage case-studies carousel (phone only: scroll-snap + arrows + dots). */
(function () {
  function init(root) {
    var track = root.querySelector('[data-nl-track]');
    if (!track) return;
    var prev = root.querySelector('[data-nl-prev]');
    var next = root.querySelector('[data-nl-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nl-dot]'));
    var slides = root.querySelectorAll('.nl-cases__slide');

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slides.length ? slides[0].getBoundingClientRect().width + gap : track.clientWidth;
    }
    function current() { return Math.round(track.scrollLeft / step()); }
    function go(i) { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }

    // Only show an arrow when there is somewhere for it to go (Scott, 2026-10-07).
    function updateArrows(i) {
      if (prev) prev.classList.toggle('is-off', i <= 0);
      if (next) next.classList.toggle('is-off', i >= slides.length - 1);
    }
    updateArrows(current());

    if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, current() + 1)); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-nl-dot'), 10) || 0); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = current();
        dots.forEach(function (dot, j) { dot.classList.toggle('is-active', i === j); });
        updateArrows(i);
        ticking = false;
      });
    }, { passive: true });
  }

  function boot() { document.querySelectorAll('[data-nl-cases]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
